import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { Outlet } from "react-router-dom";
import classes from "./Layout.module.css";
import TopBar from "./TopBar";
import NavBar from "./NavBar";
import NavInfoBar from "./NavInfoBar";
import './Layout.css';
import * as common from "../../Common/common";
import AutoLogoutModal from "./AutoLogoutModal";

const Layout = (props) => {
	const [isNavOpen, setIsNavOpen] = useState(false);
	const [cookies, removeCookies ] = useCookies([]);
  const [username, setUsername] = useState("");
	const [userId, setUserId] = useState("");
  const [checkLogoutShow, setCheckLogoutShow] = useState(false);

  const hideBarPages = [
		common.c_getWebLoginUrl()
	];
  
  const autoLogoutModalHide = () => {
		setCheckLogoutShow(!checkLogoutShow);
	}

	function setSideNav(star) {
		setIsNavOpen(!star);
	}

	function confirmLogout() {
		removeCookies("USER_NAME");
		removeCookies("USER_ID");
		removeCookies("AUTO_LOGOUT_DURATION");
		window.location = common.c_getWebLoginUrl() + "Login";
	}

	function confirmAutoLogout(){
		setCheckLogoutShow(!checkLogoutShow);
		confirmLogout();
	}

	function checkBeforeLogout() {
		setCheckLogoutShow(!checkLogoutShow);
		var autoLogoutConfirm = window.setTimeout(() => confirmLogout(), 30 * 1000);
		document.onmousedown = () => {
			resetLogoutTimeout(autoLogoutConfirm);
		}
		document.onkeydown = () => {
			resetLogoutTimeout(autoLogoutConfirm);
		}
	}

	function resetLogoutTimeout(autoLogout) {
		window.clearTimeout(autoLogout);
		autoLogout = window.setTimeout(() => checkBeforeLogout(), cookies.AUTO_LOGOUT_DURATION * 60 * 1000);
		document.onmousedown = () => {
			setCheckLogoutShow(false);
			resetLogoutTimeout(autoLogout);
		}
		document.onkeydown = () => {
			setCheckLogoutShow(false);
			resetLogoutTimeout(autoLogout);
		}
	}

  useEffect(() => {
		if (Object.keys(cookies).length !== 0 && cookies.USER_ID.trim() !== "") {
			setUsername(cookies.USER_NAME);
			setUserId(cookies.USER_ID);
			var autoLogout = window.setTimeout(() => checkBeforeLogout(), cookies.AUTO_LOGOUT_DURATION * 60 * 1000);
			document.onmousedown = () => {
				resetLogoutTimeout(autoLogout);
			}
			document.onkeydown = () => {
				resetLogoutTimeout(autoLogout);
			}
		}
	}, [cookies.USER_ID]);

  return (
    <>
      <div className={classes.app}>
					<TopBar
						setNav={setSideNav}
						hideBarPages={hideBarPages} 
						confirmLogout={confirmLogout} 
					/>
				<div className={classes.right}>
					<NavBar
						sideNavBar={isNavOpen}
						setSideNavBar={setIsNavOpen}
						hideBarPages={hideBarPages}
					/>
					<div className={classes.center}>
						<NavInfoBar />
						<main className={classes.main}><Outlet /></main>
					</div>
				</div>
			</div>

			<AutoLogoutModal 
				onHide={autoLogoutModalHide} 
				showHide={checkLogoutShow}
				confirmLogout={confirmAutoLogout} 
				resetLogoutTimeout={autoLogoutModalHide}
			/>
    </>
  );
};

export default Layout;

